module.exports = __webpack_public_path__ + "img/psaltire-1780-pagina-de-titlu-big.a697b8ed.jpg";